import React from "react";
import "../accountingPackage/pricing.css";

const addons = [
  {
    service: "Bokslut, årsredovisning och deklarationer",
    price: "499 kr / tim",
    description:
      "Bokslut, årsbokslut och årsredovisningar med full dokumentation samt moms- och inkomstdeklarationer.",
  },
  {
    service: "Extra löner",
    price: "149 kr / person och månad",
    description:
      "Lönehantering för en anställd ingår i ditt paket. Lägg till fler vid behov.",
  },
];

const AddonServices = () => (
  <section className="thas-pricing-addons" aria-labelledby="addons-heading">
    <div className="thas-pricing-container">
      <div className="thas-pricing-addons-heading">
        <div>
          <p className="thas-pricing-eyebrow">När du behöver mer</p>
          <h2 id="addons-heading">Tilläggstjänster</h2>
        </div>
        <p>Komplettera ditt paket efter verksamhetens behov.</p>
      </div>
      <div className="thas-pricing-addon-grid">
        {addons.map((addon) => (
          <article className="thas-pricing-addon" key={addon.service}>
            <span className="thas-pricing-addon-icon" aria-hidden="true">+</span>
            <div>
              <h3>{addon.service}</h3>
              <p>{addon.description}</p>
              <p className="thas-pricing-addon-amount">{addon.price}</p>
            </div>
          </article>
        ))}
      </div>
      <p className="thas-pricing-note">Samtliga priser anges exkl. moms.</p>
    </div>
  </section>
);

export default AddonServices;
